// ICE 路徑(ice_method)判定:取 getStats() 的 **selected** candidate-pair → local
// candidateType(host/srflx/relay;spec 15 §7 line 362「取 selected-candidate-pair」)。
//
// ⚠️ 不可用「nominated===true、掃全部 last-wins」:連線存活期間可能**同時**有多組
// succeeded+nominated 的 candidate-pair(host/srflx 一組、relay 一組,連通檢查都過、都曾被
// 提名)。last-wins 取決於 getStats() 回的 Map 迭代順序、而該順序跨次呼叫不保證穩定 →
// **即使媒體穩穩走同一條,指示器也會在 srflx/relay 間抖**(誤報「p2p↔relay 跳來跳去」)。
// 權威「當下正在用」的 pair = transport.selectedCandidatePairId。

type StatRec = Record<string, unknown>;

/**
 * 從 getStats() 的 id→record map 取「當下真正在用」的 candidate-pair。
 * 優先序:transport.selectedCandidatePairId(權威)→ candidate-pair.selected(舊瀏覽器)
 * → succeeded+nominated 的**第一組**(穩定、非 last-wins)→ null。
 */
export function selectedCandidatePair(byId: Map<string, StatRec>): StatRec | null {
  for (const rec of byId.values()) {
    if (rec.type === 'transport' && rec.selectedCandidatePairId != null) {
      const p = byId.get(String(rec.selectedCandidatePairId));
      if (p) return p;
    }
  }
  for (const rec of byId.values()) {
    if (rec.type === 'candidate-pair' && rec.selected === true) return rec;
  }
  for (const rec of byId.values()) {
    if (rec.type === 'candidate-pair' && rec.state === 'succeeded' && rec.nominated === true) {
      return rec;
    }
  }
  return null;
}

/** selected candidate-pair 的 local candidateType(host/srflx/relay);無則 null。 */
export function pickIceMethod(byId: Map<string, StatRec>): string | null {
  const pair = selectedCandidatePair(byId);
  if (!pair) return null;
  const lc = byId.get(String(pair.localCandidateId));
  const t = lc?.candidateType;
  return t != null ? String(t) : null;
}
